import { FREE_BRONZE_CATEGORIES } from '../constants';

const bronzePackages = [
  {
    max: 14999,
    min: 7000,
    bronzePackage: 'Bronze Basic',
  },
  {
    max: 29999,
    min: 15000,
    bronzePackage: 'Bronze Standard',
  },
  {
    max: 35000,
    min: 30000,
    bronzePackage: 'Bronze Plus',
  },
];

const packages = {
  package1: 'Platinum',
  package2: 'Gold',
  package3: 'Silver',
  package4: 'Bronze',
};

const basicAdCodes = ['cb', 'cf', 'cr'];

const freeBronze = (category = '') =>
  FREE_BRONZE_CATEGORIES.includes(category.toLowerCase());

const getBronzeType = categoryScore => {
  const { bronzePackage } =
    bronzePackages.find(
      ({ max, min }) => categoryScore <= max && categoryScore >= min
    ) || {};

  return bronzePackage;
};

const checkIsFreeBronze = category => {
  const cats = [...(Array.isArray(category) ? category : [category])];
  return cats.some(cat => freeBronze(cat));
};

const checkIsBasic = adCode =>
  basicAdCodes.includes(adCode ? adCode.toLowerCase() : '');

const getPackage = ({
  categoryScore = 0,
  packageType = '',
  category = '',
  paid,
  adCode,
  freeGoldPackage,
}) => {
  let packageName = 'Non Client';

  const isFreeBronze = checkIsFreeBronze(category);

  const isBasic = checkIsBasic(adCode);
  const bronzeType = getBronzeType(categoryScore);
  const packageConversion = packages[packageType];

  if (paid) {
    packageName = 'Paid';
  }

  if (packageConversion) {
    packageName = packageConversion;
  }

  if (bronzeType) {
    packageName = bronzeType;
  }

  if (isFreeBronze && !paid) {
    packageName = 'Bronze Free';
  }

  if (isBasic) {
    packageName = 'Basic';
  }

  if (freeGoldPackage) {
    packageName = 'Free Package';
  }

  return packageName;
};

export default getPackage;
